import React from "react";

// Uses the real Cresent Bank bull mark (transparent PNG) + a light wordmark
// so it reads clearly on the dark navy surfaces across the site.
export default function Logo({ size = "md" }) {
  const markH = size === "lg" ? 52 : size === "sm" ? 30 : 40;
  const nameSize = size === "lg" ? "text-3xl" : size === "sm" ? "text-base" : "text-xl";
  const subSize = size === "lg" ? "text-[10px]" : "text-[8px]";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src="/cresent_mark.png"
        alt="Cresent Bank"
        style={{ height: markH }}
        className="w-auto object-contain drop-shadow-[0_2px_8px_rgba(216,174,78,0.25)]"
      />
      <div className="leading-none">
        <span className={`font-serif font-bold tracking-wide ${nameSize} text-white block`}>
          CRESENT <span className="gold-text">BANK</span>
        </span>
        {size !== "sm" && (
          <span className={`${subSize} uppercase tracking-[0.35em] text-slate-400 block mt-1`}>
            Global Financial Markets
          </span>
        )}
      </div>
    </div>
  );
}
